import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import dic from "@src/common/utils/dic";
const tableOption = function (that) {
  return {
    view: "详情",
    page: true,
    selection: false,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: "700px",
    emptyText: "暂无数据",
    column: [
      {
        label: "布控分类",
        prop: "controlRecordType",
        viewDisplay: true,
        overHidden: true,
        span: 24,
        formatter: function (row, value) {
          return dic.findByValue("SENU081", value);
        },
        viewFormatter: function (row, value) {
          return dic.findByValue("SENU081", value);
        }
      },
      {
        label: "布控名称",
        prop: "controlRecordName",
        viewDisplay: true,
        clearable: true,
        search: true,
        overHidden: true,
        align: "center",
        searchPlaceholder: "请输入任务名称",
        span: 24
      },
      // {
      //   label: '是否启用',
      //   prop: 'status',
      //   search: true,
      //   align: 'center',
      //   type: 'select',
      //   dicData: [
      //     {
      //       label: '启用',
      //       value: '1'
      //     },
      //     {
      //       label: '停用',
      //       value: '2'
      //     }
      //   ],
      //   formatter: function (row, value) {
      //     return value === '1' ? '启用' : '停用';
      //   },
      //   viewFormatter: function (row, value) {
      //     return value === '1' ? '启用' : '停用';
      //   },
      // },
      // {
      //   label: "布控类型",
      //   prop: "controlSubType",
      //   align: "center",
      //   viewDisplay: true,
      //   span: 24,
      //   formatter: function (row, value) {
      //     return dic.findByValue("SENU090", value);
      //   }
      // },
      {
        label: "布控对象",
        prop: "repositoriesNames",
        align: "center",
        viewDisplay: true,
        span: 24
      },
      {
        label: "创建时间",
        search: true,
        // type: 'datetimerange',
        prop: "createTime",
        searchSlot: true,
        viewDisplay: true,
        span: 24
      },
      {
        label: "布控描述",
        prop: "desc",
        viewDisplay: true,
        span: 24
      }
    ]
  };
};
export default tableOption;
